import { z } from 'zod';
import { api } from './api';
import {
  businessUnitSchema,
  expensesResponseSchema,
  kpiResponseSchema,
  pnlResponseSchema,
  pnlSourceResponseSchema,
  type BusinessUnit,
  type ExpensesResponse,
  type KpiResponse,
  type PnlResponse,
  type PnlSourceResponse,
} from '@/types/schemas';

export const businessUnitsService = {
  list: (signal?: AbortSignal): Promise<BusinessUnit[]> =>
    api.get('/business-units', z.array(businessUnitSchema), signal),

  create: (input: { name: string; type: string; status?: string }): Promise<BusinessUnit> =>
    api.post('/business-units', businessUnitSchema, input),

  kpis: (unitId: string, periodId?: string, signal?: AbortSignal): Promise<KpiResponse> =>
    api.get(
      `/business-units/${unitId}/kpis${periodId ? `?period_id=${periodId}` : ''}`,
      kpiResponseSchema,
      signal,
    ),

  pnl: (unitId: string, year: number, signal?: AbortSignal): Promise<PnlResponse> =>
    api.get(`/business-units/${unitId}/pnl?year=${year}`, pnlResponseSchema, signal),

  /** «Отчёт ОПУ» — the confirmed workbook itself, not the canonical model. */
  pnlSource: (unitId: string, year: number, signal?: AbortSignal): Promise<PnlSourceResponse> =>
    api.get(`/business-units/${unitId}/pnl/source?year=${year}`, pnlSourceResponseSchema, signal),

  expenses: (unitId: string, periodId?: string, signal?: AbortSignal): Promise<ExpensesResponse> =>
    api.get(
      `/business-units/${unitId}/expenses${periodId ? `?period_id=${periodId}` : ''}`,
      expensesResponseSchema,
      signal,
    ),
};
